

















import Vue from 'vue';
import Component from 'vue-class-component';
import { GridColumn } from '@/models/GridColumn.model';
import { Action, Getter } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Grid } from '@/models/Grid.model';
import { ALL_CUSTOMERS, GET_ALL_CUSTOMERS, GET_CUSTOMER_DETAILS } from '@/types/customer.types';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';

@Component({})
export default class CustomersListComponent extends Vue {

  @Action(GET_ALL_CUSTOMERS, StoreNamespace.CUSTOMER) public getAllCustomers;
  @Action(GET_CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public getCustomerDetails;

  @Getter(ALL_CUSTOMERS, StoreNamespace.CUSTOMER) public allCustomers!: Grid;

  private columns: GridColumn[] = [];

  public mounted() {
    this.getAllCustomers();
    this.initColumns();
  }

  private initColumns() {
    this.columns.push({
      property: 'indexNum',
      header: 'back_office.settings.offices.indexNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'indexName',
      header: 'back_office.settings.offices.indexName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'activeInForm101',
      header: 'back_office.settings.offices.activeFlag',
      hideSorting: true,
      booleanProperty: true,
      trueValue: '' + this.$t('back_office.settings.offices.active'),
      falseValue: '' + this.$t('back_office.settings.offices.unActive'),
    } as GridColumn);
  }

  private onRowClicked(item: CustomerDetailsModel) {
    this.getCustomerDetails(item.indexNum);
  }

}

